module.exports = __webpack_public_path__ + "img/fineness-2.7ea0733.webp";